"use client";

import NextLink from "next/link";
import type { ComponentProps } from "react";

/**
 * Link de Next con prefetch desactivado.
 * El prefetch de App Router puede devolver un payload RSC parcial que, al
 * hacer clic, acaba en "This page couldn't load" (React #412).
 */
export function AppLink({ prefetch = false, ...props }: ComponentProps<typeof NextLink>) {
  return <NextLink prefetch={prefetch} {...props} />;
}
